import { create } from 'zustand';

/**
 * Zustand Store for Contacts Management
 * Global state management for contacts
 * TODO: Add persistence after implementing auth
 */

const useContactStore = create((set, get) => ({
  // State
  contacts: [],
  selectedContact: null,
  loading: false,
  error: null,
  searchQuery: '',
  filters: {
    type: '', // 'individual' or 'company'
    category: '', // 'client', 'supplier', 'partner', 'internal'
    isActive: true,
  },
  pagination: {
    limit: 20,
    offset: 0,
    total: 0,
  },

  // Actions
  setContacts: (contacts) => set({ contacts }),
  setSelectedContact: (contact) => set({ selectedContact: contact }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  setFilters: (filters) => set((state) => ({ filters: { ...state.filters, ...filters } })),
  setPagination: (pagination) => set((state) => ({ pagination: { ...state.pagination, ...pagination } })),

  // Clear state
  clearSelectedContact: () => set({ selectedContact: null }),
  clearError: () => set({ error: null }),
  resetFilters: () => set({
    filters: { type: '', category: '', isActive: true },
    searchQuery: '',
    pagination: { limit: 20, offset: 0, total: 0 },
  }),

  // Computed helpers
  getContactById: (id) => {
    const { contacts } = get();
    return contacts.find((c) => c.id === id) || null;
  },

  getFilteredContacts: () => {
    const { contacts, searchQuery, filters } = get();

    return contacts.filter((contact) => {
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        const matches =
          contact.name.toLowerCase().includes(query) ||
          contact.email?.toLowerCase().includes(query) ||
          contact.company_name?.toLowerCase().includes(query);
        if (!matches) return false;
      }

      if (filters.type && contact.type !== filters.type) return false;
      if (filters.category && contact.category !== filters.category) return false;
      if (contact.is_active !== filters.isActive) return false;

      return true;
    });
  },

  getTotalInvoices: () => {
    const { selectedContact } = get();
    return selectedContact?.invoice_count || 0;
  },
}));

export default useContactStore;
